"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const templateLibraryApi_1 = require("../api/templateLibraryApi");
const sessionBuilder_1 = require("../api/sessionBuilder");
function TabPanel(props) {
    const { children, value, index } = props, other = __rest(props, ["children", "value", "index"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ role: "tabpanel", hidden: value !== index, id: `template-tabpanel-${index}`, "aria-labelledby": `template-tab-${index}` }, other, { children: value === index && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { p: 3 }, children: children })) })));
}
function a11yProps(index) {
    return {
        id: `template-tab-${index}`,
        'aria-controls': `template-tabpanel-${index}`,
    };
}
// Special blank template for starting from scratch
const BLANK_TEMPLATE = {
    id: -1, // Special ID to identify blank template
    name: 'Blank Template',
    description: 'Start with a clean slate',
    docType: sessionBuilder_1.DOC_TYPE.PPT,
    accessLevel: templateLibraryApi_1.TemplateAccessLevel.PUBLIC,
    html: '<div class="presentation-slide"><h1>Your Presentation</h1><p>Start building your content here...</p></div>',
    thumbnailUrl: undefined,
    previewUrl: undefined,
    tags: ['blank', 'starter'],
    usageCount: 0,
    isActive: true,
    appId: '',
    customerId: '',
    orgId: '',
    createdBy: '',
    createdAt: '',
    updatedAt: '',
};
const TemplateSelectionModal = ({ open, onClose, onSelectTemplate, docType, }) => {
    const [templates, setTemplates] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [searchTerm, setSearchTerm] = (0, react_1.useState)('');
    const [selectedAccessLevel, setSelectedAccessLevel] = (0, react_1.useState)('');
    const [selectedTag, setSelectedTag] = (0, react_1.useState)('');
    const [tabValue, setTabValue] = (0, react_1.useState)(0);
    const [page, setPage] = (0, react_1.useState)(1);
    const [total, setTotal] = (0, react_1.useState)(0);
    const [availableTags, setAvailableTags] = (0, react_1.useState)([]);
    const [selectedTemplate, setSelectedTemplate] = (0, react_1.useState)(null);
    const [sessionName, setSessionName] = (0, react_1.useState)('');
    const [isCreating, setIsCreating] = (0, react_1.useState)(false);
    const limit = 12;
    const fetchTemplates = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (params = {}) {
        setLoading(true);
        setError(null);
        try {
            const response = yield templateLibraryApi_1.templateLibraryApi.getTemplates(Object.assign({ docType, search: searchTerm || undefined, accessLevel: selectedAccessLevel || undefined, tag: selectedTag || undefined, page,
                limit, sortBy: 'usageCount', sortOrder: 'DESC' }, params));
            setTemplates(response.templates);
            setTotal(response.total);
            // Extract unique tags from all templates
            const allTags = response.templates
                .flatMap(t => t.tags || [])
                .filter((tag, index, arr) => arr.indexOf(tag) === index);
            setAvailableTags(allTags);
        }
        catch (err) {
            setError(err.message || 'Failed to fetch templates');
        }
        finally {
            setLoading(false);
        }
    });
    (0, react_1.useEffect)(() => {
        if (open) {
            fetchTemplates();
        }
    }, [open, docType, page]);
    (0, react_1.useEffect)(() => {
        const debounceTimer = setTimeout(() => {
            if (open) {
                setPage(1);
                fetchTemplates({ page: 1 });
            }
        }, 500);
        return () => clearTimeout(debounceTimer);
    }, [searchTerm, selectedAccessLevel, selectedTag]);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setSelectedAccessLevel(newValue === 0 ? '' : newValue === 1 ? templateLibraryApi_1.TemplateAccessLevel.ORGANIZATION : templateLibraryApi_1.TemplateAccessLevel.PERSONAL);
    };
    const handleSelectTemplate = (template) => {
        setSelectedTemplate(template);
        // Auto-fill session name based on template name
        if (!sessionName) {
            setSessionName(template.name === 'Blank Template' ? 'New Presentation' : template.name);
        }
    };
    const handleCreateSession = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedTemplate || !sessionName.trim()) {
            return;
        }
        setIsCreating(true);
        try {
            // Prepare the template data for session creation
            const templateData = {
                name: sessionName.trim(),
                html: selectedTemplate.id === -1 ? null : (selectedTemplate.html || null), // null for blank template or undefined html
                templateId: selectedTemplate.id === -1 ? undefined : selectedTemplate.id, // undefined for blank template
            };
            yield onSelectTemplate(templateData);
            // Only close modal if onSelectTemplate succeeds (no error thrown)
            onClose();
        }
        catch (err) {
            console.error('Failed to create session:', err);
            setError('Failed to create session. Please try again.');
            // Don't close modal on error - let user try again
        }
        finally {
            setIsCreating(false);
        }
    });
    const handleClose = () => {
        setSearchTerm('');
        setSelectedAccessLevel('');
        setSelectedTag('');
        setTabValue(0);
        setPage(1);
        setError(null);
        setSelectedTemplate(null);
        setSessionName('');
        setIsCreating(false);
        onClose();
    };
    const getAccessLevelLabel = (accessLevel) => {
        switch (accessLevel) {
            case templateLibraryApi_1.TemplateAccessLevel.PUBLIC:
                return 'Public';
            case templateLibraryApi_1.TemplateAccessLevel.ORGANIZATION:
                return 'Organization';
            case templateLibraryApi_1.TemplateAccessLevel.PERSONAL:
                return 'Personal';
            default:
                return accessLevel;
        }
    };
    const getAccessLevelColor = (accessLevel) => {
        switch (accessLevel) {
            case templateLibraryApi_1.TemplateAccessLevel.PUBLIC:
                return 'success';
            case templateLibraryApi_1.TemplateAccessLevel.ORGANIZATION:
                return 'primary';
            case templateLibraryApi_1.TemplateAccessLevel.PERSONAL:
                return 'secondary';
            default:
                return 'default';
        }
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Dialog, { open: open, onClose: handleClose, maxWidth: "lg", fullWidth: true, PaperProps: {
            sx: { minHeight: '80vh' }
        }, children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", justifyContent: "space-between", alignItems: "center", children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "h6", children: ["Select Template for ", docType.toUpperCase()] }), (0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: handleClose, size: "small", children: (0, jsx_runtime_1.jsx)(icons_material_1.Close, {}) })] }) }), (0, jsx_runtime_1.jsxs)(material_1.DialogContent, { dividers: true, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { mb: 3, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", flexDirection: { xs: 'column', md: 'row' }, gap: 2, alignItems: "center", children: [(0, jsx_runtime_1.jsx)(material_1.Box, { flex: 1, minWidth: 0, children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, placeholder: "Search templates...", value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), InputProps: {
                                            startAdornment: (0, jsx_runtime_1.jsx)(icons_material_1.Search, { sx: { mr: 1, color: 'text.secondary' } }),
                                        } }) }), (0, jsx_runtime_1.jsx)(material_1.Box, { minWidth: 200, children: (0, jsx_runtime_1.jsxs)(material_1.FormControl, { fullWidth: true, children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: "Filter by Tag" }), (0, jsx_runtime_1.jsxs)(material_1.Select, { value: selectedTag, onChange: (e) => setSelectedTag(e.target.value), label: "Filter by Tag", children: [(0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: "", children: (0, jsx_runtime_1.jsx)("em", { children: "All Tags" }) }), availableTags.map((tag) => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: tag, children: tag }, tag)))] })] }) })] }) }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { borderBottom: 1, borderColor: 'divider' }, children: (0, jsx_runtime_1.jsxs)(material_1.Tabs, { value: tabValue, onChange: handleTabChange, "aria-label": "template access level tabs", children: [(0, jsx_runtime_1.jsx)(material_1.Tab, Object.assign({ label: "All Templates" }, a11yProps(0))), (0, jsx_runtime_1.jsx)(material_1.Tab, Object.assign({ label: "Organization" }, a11yProps(1))), (0, jsx_runtime_1.jsx)(material_1.Tab, Object.assign({ label: "Personal" }, a11yProps(2)))] }) }), error && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "error", sx: { mt: 2 }, children: error })), loading ? ((0, jsx_runtime_1.jsx)(material_1.Box, { display: "flex", justifyContent: "center", alignItems: "center", minHeight: "300px", children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TabPanel, { value: tabValue, index: 0, children: (0, jsx_runtime_1.jsx)(TemplateCardGrid, { templates: [BLANK_TEMPLATE, ...templates], selectedTemplate: selectedTemplate, onSelectTemplate: handleSelectTemplate, getAccessLevelLabel: getAccessLevelLabel, getAccessLevelColor: getAccessLevelColor }) }), (0, jsx_runtime_1.jsx)(TabPanel, { value: tabValue, index: 1, children: (0, jsx_runtime_1.jsx)(TemplateCardGrid, { templates: [BLANK_TEMPLATE, ...templates.filter(t => t.accessLevel === templateLibraryApi_1.TemplateAccessLevel.ORGANIZATION)], selectedTemplate: selectedTemplate, onSelectTemplate: handleSelectTemplate, getAccessLevelLabel: getAccessLevelLabel, getAccessLevelColor: getAccessLevelColor }) }), (0, jsx_runtime_1.jsx)(TabPanel, { value: tabValue, index: 2, children: (0, jsx_runtime_1.jsx)(TemplateCardGrid, { templates: [BLANK_TEMPLATE, ...templates.filter(t => t.accessLevel === templateLibraryApi_1.TemplateAccessLevel.PERSONAL)], selectedTemplate: selectedTemplate, onSelectTemplate: handleSelectTemplate, getAccessLevelLabel: getAccessLevelLabel, getAccessLevelColor: getAccessLevelColor }) }), templates.length === 0 && !loading && ((0, jsx_runtime_1.jsx)(material_1.Box, { textAlign: "center", py: 4, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", color: "text.secondary", children: "No templates found. Try adjusting your search criteria." }) }))] }))] }), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { sx: { p: 3, flexDirection: 'column', gap: 2 }, children: [selectedTemplate && ((0, jsx_runtime_1.jsx)(material_1.Box, { width: "100%", children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, label: "Session Name", value: sessionName, onChange: (e) => setSessionName(e.target.value), placeholder: "Enter session name...", variant: "outlined", required: true, error: !sessionName.trim() && selectedTemplate !== null, helperText: !sessionName.trim() && selectedTemplate !== null ? "Session name is required" : "" }) })), (0, jsx_runtime_1.jsxs)(material_1.Box, { width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", children: [(0, jsx_runtime_1.jsx)(material_1.Button, { onClick: handleClose, color: "primary", disabled: isCreating, children: "Cancel" }), selectedTemplate && ((0, jsx_runtime_1.jsx)(material_1.Button, { onClick: handleCreateSession, variant: "contained", color: "primary", disabled: !sessionName.trim() || isCreating, startIcon: isCreating ? (0, jsx_runtime_1.jsx)(material_1.CircularProgress, { size: 16 }) : null, children: isCreating ? 'Creating...' : 'Create' }))] })] })] }));
};
const TemplateCardGrid = ({ templates, selectedTemplate, onSelectTemplate, getAccessLevelLabel, getAccessLevelColor, }) => {
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { display: "grid", gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)'
        }, gap: 2, children: templates.map((template) => {
            var _a;
            const isBlankTemplate = template.id === -1;
            const isSelected = (selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.id) === template.id;
            return ((0, jsx_runtime_1.jsxs)(material_1.Card, { sx: {
                    cursor: 'pointer',
                    transition: 'transform 0.2s',
                    border: isSelected
                        ? '2px solid #1976d2'
                        : isBlankTemplate
                            ? '2px dashed #e0e0e0'
                            : '1px solid #e0e0e0',
                    backgroundColor: isSelected ? '#e3f2fd' : 'white',
                    '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: 4,
                        border: isSelected
                            ? '2px solid #1976d2'
                            : isBlankTemplate
                                ? '2px dashed #1976d2'
                                : '1px solid #e0e0e0',
                    },
                }, onClick: () => onSelectTemplate(template), children: [isBlankTemplate ? ((0, jsx_runtime_1.jsxs)(material_1.Box, { height: "140", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", sx: {
                            backgroundColor: '#f5f5f5',
                            border: '2px dashed #e0e0e0',
                        }, children: [(0, jsx_runtime_1.jsx)(icons_material_1.Add, { sx: {
                                    fontSize: 48,
                                    color: 'text.secondary',
                                    mb: 1
                                } }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", color: "text.secondary", children: "Start Fresh" })] })) : (template.thumbnailUrl && ((0, jsx_runtime_1.jsx)(material_1.CardMedia, { component: "img", height: "140", image: template.thumbnailUrl, alt: template.name, sx: { objectFit: 'cover' } }))), (0, jsx_runtime_1.jsxs)(material_1.CardContent, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1, children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "h6", component: "div", noWrap: true, sx: {
                                            fontWeight: isBlankTemplate ? 600 : 400,
                                            color: isSelected ? 'primary.main' : 'text.primary'
                                        }, children: [template.name, isSelected && ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "span", sx: { ml: 1, fontSize: '0.8em' }, children: "\u2713" }))] }), (0, jsx_runtime_1.jsx)(material_1.Chip, { label: getAccessLevelLabel(template.accessLevel), color: getAccessLevelColor(template.accessLevel), size: "small" })] }), template.description && ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body2", color: "text.secondary", mb: 1, children: template.description })), (0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", flexWrap: "wrap", gap: 0.5, mb: 1, children: [(_a = template.tags) === null || _a === void 0 ? void 0 : _a.slice(0, 3).map((tag) => ((0, jsx_runtime_1.jsx)(material_1.Chip, { label: tag, size: "small", variant: "outlined" }, tag))), template.tags && template.tags.length > 3 && ((0, jsx_runtime_1.jsx)(material_1.Chip, { label: `+${template.tags.length - 3}`, size: "small", variant: "outlined" }))] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", color: "text.secondary", children: isBlankTemplate ? 'Always available' : `Used ${template.usageCount} times` })] })] }, template.id));
        }) }));
};
exports.default = TemplateSelectionModal;
